module.exports = __webpack_public_path__ + "img/university_6.9a1b64a8.png";